import type { DownloadButtonProps } from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';

export const snapshotAppDownloadItems: DownloadButtonProps[] = [
    {
        storeLink: {
            href: 'https://apps.apple.com/us/app/siriusxm-music-sports-news/id317951436',
            target: '_blank',
        },
        badgeSrc: 'https://www.siriusxm.com/content/dam/sxm-com/logos/banners/App_Store_Badge_download.svg',
        type: 'appleStore',
    },
    {
        storeLink: {
            href: 'https://play.google.com/store/apps/details?id=com.sirius&hl=en&gl=US',
            target: '_blank',
        },
        badgeSrc: 'https://www.siriusxm.com/content/dam/sxm-com/logos/banners/Google_Play_Store_badge_EN.svg',
        type: 'playStore',
    },
];
